import { DISPUTE_STATUS } from "../utils/enums";
import SortDropdown from "./SortDropdown";

const OPTIONS = [
  { value: DISPUTE_STATUS.ALL, label: "All" },
  { value: DISPUTE_STATUS.NEW, label: "New" },
  { value: DISPUTE_STATUS.INPROGRESS, label: "In-Progress" },
  { value: DISPUTE_STATUS.RESOLVED, label: "Resolved" },
];

const DisputeStatusDropdown = ({ value, onChange }: any) => (
  <SortDropdown
    label="Status"
    icon="bi-funnel"
    options={OPTIONS}
    value={value || DISPUTE_STATUS.ALL}
    onChange={onChange}
  />
);

export default DisputeStatusDropdown;
